import MappingBase from './mappingBase.js';

class Theme extends MappingBase {
  constructor({
    id = null,
    name = null,
    category = null,
    primaryColor = null,
    secondaryColor = null,
    backgroundColor = null,
    textColor = null,
    accentColor = null,
    createdAt = null,
    updatedAt = null
  } = {}) {
    super();
    this.id = id;
    this.name = name;
    this.category = category;
    this.primaryColor = primaryColor;
    this.secondaryColor = secondaryColor;
    this.backgroundColor = backgroundColor;
    this.textColor = textColor;
    this.accentColor = accentColor;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  static _aliasMapping = {
    id: 'id',
    nm: 'name',
    cat: 'category',
    pc: 'primaryColor',
    sc: 'secondaryColor',
    bc: 'backgroundColor',
    tc: 'textColor',
    ac: 'accentColor',
    ca: 'createdAt',
    ua: 'updatedAt',
  };
}

export default Theme;
